module.exports = __webpack_public_path__ + "static/media/6.47a69897.jpg";